import { render, staticRenderFns } from "./IconPhoto.vue?vue&type=template&id=c4394c9e&functional=true&"
import script from "./IconPhoto.vue?vue&type=script&lang=js&"
export * from "./IconPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports